import '../../utils/index.mjs';
import Text from './src/text.mjs';
export { textProps } from './src/text2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElText = withInstall(Text);

export { ElText, ElText as default };
//# sourceMappingURL=index.mjs.map
